import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import {useParams } from 'react-router-dom'
import Swal from 'sweetalert2';
import { UserContext } from '../../../Context/UserContext.js';

export default function SpecificPatient() {
   const {id} = useParams();

   const {userToken } = useContext(UserContext) ;
   const [patient ,  setPatient] = useState({}) ;
   const [history ,  setHistory] = useState({}) ;

   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   async function getSpecificPatient (){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/patient/${id}`  ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setPatient(data.patient)        
         }
      })
      .catch((error)=>{
         Swal({
            title:error.response.data.message  ,
            text: "Please Try Again" ,   
            icon: "error"
            });
      })
   }

   async function getHistorySpecificPatient (){
      setHistory(patient.createdBy)        
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/history/${patient.user}`  ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setHistory(data.history)        
         }
      })
      .catch((error)=>{
         console.log(error);
         
      })
   }



   useEffect(() => {
      getSpecificPatient() ;
      getHistorySpecificPatient()
   },[])
   

   return (
      <Fragment>
         {console.log("patient" , patient)}
         {console.log("history" , history)}
         <div className="container mt-5 homeDashboard">
            <h1 className='main-header'>Specific Patient</h1>
            <div className='under-header'></div>

            <div className="row ">
               <div className="col-md-12 mb-4">
                  <h4 className=''>Patient Information :</h4>
                  <div className='border border-1 p-2 rounded-2'>
                     
                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">patient_Name :</th>
                              <td className='text-center'>{patient.patient_Name}</td>
                           </tr>
                           <tr>
                              <th scope="row">patient_Age :</th>
                              <td className='text-center'>{patient.patient_Age}</td>
                           </tr>
                           <tr>
                              <th scope="row">gender:</th>
                              <td className='text-center'>{patient.gender}</td>
                           </tr>
                           <tr>
                              <th scope="row">patient_Phone:</th>
                              <td className='text-center'>{patient.patient_Phone}</td>
                           </tr>
                           <tr>
                              <th scope="row">birthDay:</th>
                              <td className='text-center'>{patient.birthDay?.slice(0 , 10)}</td>
                           </tr>
                        </tbody>

                     </table>

                  </div>
               </div>

               <div className='col-md-12'>

               </div>
            </div>
         </div>
      </Fragment>
   )
}
